import React from "react";
import Icon from "./Icon";
import Loading from "./Loading";

const ButtonT = ({ text, onClick, borderBlue, path, link,showloading }) => {
  return (
    <>
      {!link ? (
        <button
          className={` ${borderBlue?borderBlue:"border-2 border-gray"} border-solid flex flex-row  items-center px-3.5 py-2.5 text-dark-blue-200 font-normal text-12 rounded-sm leading-5.4 gap-2.2 h-10`}
          onClick={onClick}>
      {text}
          
          <Icon iconName="arrow-leftD" />
        </button>
      ) : (
        <a href={path}>
          <button
            className={`border-2 border-gray border-solid flex flex-row  items-center px-3.5 py-2.5 text-dark-blue-200 font-normal text-12 rounded-sm leading-5.4 gap-2.2 h-10 ${borderBlue} `}
            onClick={onClick}>
            
              {text}
            
            <Icon iconName="arrow-leftD" />
          </button>
        </a>
      )}
    </>
  );
};

export default ButtonT;
